import React from "react";
import { decorators, Paginator } from "@orange-marmalade/paginate-this";
import { translateProps } from "MODULES/shared/decorators";
import { NoteTooltip as IconTooltip } from "MODULES/shared/components";
import Heading from "./Heading";
import Table from "./Table";

export function LineItems({
  afterHours,
  company,
  results,
  isLoading,
  openRma,
  salesOrder
}) {
  const rowIcon = afterHours ? (
    <td>
      <IconTooltip
        icon={"fa-clock-o"}
        placement={"top"}
        note={"After Hours"}
        color={"#FFFFFF"}
      />
    </td>
  ) : null;

  return [
    <Heading key="heading" />,
    <Table
      company={company}
      results={results}
      isLoading={isLoading}
      openRma={openRma}
      key="table"
      rowIcon={rowIcon}
      salesOrder={salesOrder}
    />,
    <nav
      key="pagination"
      className="text-center margin-top-none"
      aria-label="Search results pages"
    >
      <Paginator listId="salesOrders/lineItems" />
    </nav>
  ];
}

const withListId = translateProps(() => ({
  listId: "salesOrders/lineItems"
}));

export default withListId(decorators.tabulate(LineItems));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/LineItems.jsx